import { computed, reactive, createElementBlock, openBlock, Fragment, renderList, createCommentVNode, createVNode } from "vue";
import _sfc_main$1 from "./option_bar_control.vue.js";
import { MEMBER_UPDATE_EVENT } from "../../lib/constants.js";
import { convert } from "../../lib/convert.js";
import { controlMap } from "../../lib/control.js";
const _hoisted_1 = {
  key: 0,
  class: "d-py6",
  "data-qa": "dtc-option-bar-member-group-control"
};
const __default__ = {
  name: "DtcOptionBarMemberGroup"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    /**
     * Target component.
     */
    component: {
      type: Object,
      required: true
    },
    /**
     * Array of members to generate controls for.
     */
    members: {
      type: Array,
      required: true
    },
    /**
     * Map of key-value pairs for each member.
     */
    values: {
      type: Object,
      required: true
    },
    /**
     * Function that determines the control selections for
     * a given member by returning an array of valid controls.
     */
    controlSelector: {
      type: Function,
      required: true
    }
  },
  emits: [MEMBER_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const memberMap = computed(() => {
      return reactive({
        ...Object.fromEntries(
          props.members.map((member) => {
            return [getMemberKey(member), extendMember(member)];
          })
        )
      });
    });
    function getMemberKey(member) {
      return member.name;
    }
    function getControlData(member) {
      return controlMap[member.control] ?? controlMap.base;
    }
    function isVModel(member) {
      const tags = member.tags;
      return tags ? "model" in tags : false;
    }
    function extendMember(member) {
      const key = getMemberKey(member);
      const value = props.values[key];
      const [validControls, control] = props.controlSelector(member, value);
      return {
        ...member,
        control,
        validControls
      };
    }
    function updateMember(e, key) {
      emit(MEMBER_UPDATE_EVENT, {
        member: key,
        value: e
      });
    }
    function updateControl(e, key) {
      const member = memberMap.value[key];
      let value;
      try {
        value = convert(member.control, e, props.values[key]);
      } catch {
        console.warn(`${member.name}: Unable to convert ${member.control} to ${e}`);
      }
      member.control = e;
      updateMember(value ?? getControlData(member).default(member), key);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(memberMap.value, (member, key) => {
          return openBlock(), createElementBlock(Fragment, { key }, [
            !member.hideControl ? (openBlock(), createElementBlock("div", _hoisted_1, [
              createVNode(_sfc_main$1, {
                value: __props.values[key],
                label: member.label,
                "control-data": getControlData(member),
                "valid-controls": member.validControls,
                description: member.description,
                "v-model": isVModel(member),
                required: member.required,
                locked: member.lockControl,
                args: {
                  defaultValue: member.defaultValue,
                  validValues: member.values,
                  validTypes: member.types,
                  tags: member.tags
                },
                "onUpdate:value": (e) => updateMember(e, key),
                "onUpdate:control": (e) => updateControl(e, key)
              }, null, 8, ["value", "label", "control-data", "valid-controls", "description", "v-model", "required", "locked", "args", "onUpdate:value", "onUpdate:control"])
            ])) : createCommentVNode("", true)
          ], 64);
        }), 128))
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=option_bar_member_group.vue.js.map
